import React from "react";
import styled from "styled-components";

const PostColumnContainer = styled.div`
  padding: 0 16px;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  ${props => props.theme.media.desktopUp`
    padding: 0;
    margin: 0;
    flex-direction: row;
    flex-wrap: wrap;
    max-width: 1170px;
  `};
`;

export default ({ children }) => (
  <PostColumnContainer>{children}</PostColumnContainer>
);
